import { render, staticRenderFns } from "./hareketler.vue?vue&type=template&id=72960110"
import script from "./hareketler.vue?vue&type=script&lang=js"
export * from "./hareketler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports